// extracted by mini-css-extract-plugin
export var container = "index-module--container--WTr6N";
export var list = "index-module--list--rd1s-";
export var section = "index-module--section--XLElN";
export var videoButton = "index-module--videoButton--EeEDp";
export var videoDarkMode = "index-module--videoDarkMode--9dlxE";
export var videoDescription = "index-module--videoDescription--UV88L";
export var videoImageContainer = "index-module--videoImageContainer--9qK2Z";
export var videoImageTextContainer = "index-module--videoImageTextContainer--78Dxq";
export var videoPreview = "index-module--videoPreview--7Qxc2";
export var videoSubtitle = "index-module--videoSubtitle--2GSVY";
export var videoTextContainer = "index-module--videoTextContainer--iyIsC";
export var videoTitle = "index-module--videoTitle--SoPyy";